import {Injectable} from '@angular/core';
import {ApiHelperService} from './api-helper.service';
import {API} from 'aws-amplify';
import {OverlayService} from './overlay.service';
import {MessageDialogComponent} from '../../views/partials/message-dialog/message-dialog.component';
import {AuthService} from './auth.service';
import {MatDialog} from '@angular/material/dialog';
import {Poem} from '../model/resources/widget';

@Injectable({
  providedIn: 'root'
})
export class PoemApiService {

  constructor(
    private apiHelperService: ApiHelperService,
    private authService: AuthService,
    private dialog: MatDialog,
    private overlayService: OverlayService,
  ) {
  }

  async getPoems(): Promise<Poem[]> {
    if (!this.authService.userAuth?.isAllowManageWidget()) {
      MessageDialogComponent.createErrorDialog(this.dialog, '権限がありません。');
      return [];
    }

    try {
      const headers = await this.apiHelperService.getBasicApiHeader();
      const init = {headers};
      return await this.overlayService.call(API.get(this.apiHelperService.apiName, `poems`, init));
    } catch (e: any) {
      MessageDialogComponent.createErrorDialog(this.dialog, e.response.data.error);
      return [];
    }
  }

  async patchPoems(poems: Poem[]): Promise<void> {
    if (!this.authService.userAuth?.isAllowManageWidget()) {
      MessageDialogComponent.createErrorDialog(this.dialog, '権限がありません。');
      return;
    }

    try {
      const headers = await this.apiHelperService.getBasicApiHeader();
      const init = {
        headers,
        body: {
          poems: poems.map(poem => {
            return {
              userId: poem.user_id,
              postedAt: poem.posted_at,
              accept: poem.accept
            };
          })
        }
      };
      return await this.overlayService.call(API.patch(this.apiHelperService.apiName, `poems`, init));
    } catch (e: any) {
      MessageDialogComponent.createErrorDialog(this.dialog, e.response.data.error);
      return;
    }
  }

}
